import { Component, OnInit, Input, Injectable } from "@angular/core";
import { UserState } from "src/app/states/user.state";
import { SignOut } from "src/app/states/actions/user.actions";
import {
  Select,
  Store,
  Actions,
  ofActionSuccessful,
  ofActionErrored,
} from "@ngxs/store";
import { Observable } from "rxjs";
import { Place, Me, Submodule, MenuItem } from "src/app/interface/user";
import { MatDialog } from "@angular/material/dialog";
import { MatDrawer } from "@angular/material/sidenav";
import { tap, delay } from "rxjs/operators";
import { Tag } from "src/app/interface/product";
import { EmployeePlacesComponent } from "../employee-places/employee-places.component";
import { DeliveryState } from "src/app/states/delivery.state";
import { DeliveryComponent } from "src/app/admin/components/delivery/delivery.component";
import {
  SubcategoriesTags,
  CategoriesTagsClient,
} from "src/app/states/actions/admin.actions";
import { AdminState } from "src/app/states/admin.state";
import { imgErrorFallback } from "src/app/helpers/helpers";
import { Router } from "@angular/router";
import { AlertService } from "src/app/services/alert.service";
import { DataService } from "src/app/services/data.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
@Injectable()
export class SidenavComponent implements OnInit {
  @Input() drawer: MatDrawer;
  @Select(UserState.me) user: Observable<Me>;
  @Select(UserState.sudo) sudo: Observable<boolean>;
  @Select(UserState.submodules) submodules: Observable<Submodule[]>;
  @Select(AdminState.categories) categories: Observable<Tag[]>;
  @Select(AdminState.subcategories) subcategories: Observable<Tag[]>;
  @Select(DeliveryState.isDelivery) delivery: Observable<boolean>;
  @Select(UserState.firebaseUser) firebaseUser: Observable<string>;
  @Select(UserState.menu) menu: Observable<MenuItem[]>;
  selectedPlace: Observable<Place>;
  actualPlace: number;
  menuItems = [
    {
      route: "/admin",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "dashboard",
      label: "Dashboard",
    },
    {
      route: "/admin/cellar",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "store",
      label: "Bodegas",
    },
    {
      route: "/admin/blackBox",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "inventory_2",
      label: "Caja Negra",
    },
    {
      route: "/admin/billing/bills",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "receipt",
      label: "Facturación",
    },
    {
      route: "/admin/gallery",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "collections",
      label: "Galería",
    },
    {
      route: "/admin/orders/pending",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "assignment_turned_in",
      label: "Órdenes",
    },
    {
      route: "/reports",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "insert_chart",
      label: "Reportes",
    },
    {
      route: "/reports/user",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "people",
      label: "Clientes",
    },
    {
      icon: "location_on",
      route: "/admin/place-profile",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Perfil de la tienda",
    },
    {
      icon: "widgets",
      route: "/admin/tags",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Categorias",
    },
    {
      icon: "person",
      route: "/admin/users",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Administradores",
    },
    {
      icon: "request_quote",
      route: "/admin/billing-profile-place",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Perfil de facturación",
    },
  ];

  constructor(
    private store: Store,
    private actions: Actions,
    private dialog: MatDialog,
    private alertService: AlertService,
    public router: Router,
    private _dataService: DataService
  ) {
    this.actions.pipe(ofActionSuccessful(SubcategoriesTags)).subscribe(() => {
      this.drawer.open();
    });
    this.actions.pipe(ofActionErrored(SubcategoriesTags)).subscribe(() => {
      this.alertService.openSnackBar("Error de conexión.", "error");
    });
  }

  ngOnInit() {
    this.actions
      .pipe(ofActionSuccessful(CategoriesTagsClient))
      .subscribe(() => {
        this.drawer.open();
      });
    this.selectedPlace = this.store.select<Place>(UserState.selectedPlace).pipe(
      delay(0),
      tap((place) => {
        if (place) {
          this.actualPlace = place.id;
        } else {
          this.actualPlace = null;
        }
      })
    );
  }

  setDelivery = (place) => {
    this.dialog.open(DeliveryComponent, {
      data: place,
      height: "100%",
      width: "100%",
      maxWidth: "100%",
      panelClass: "iframe-container",
    });
  };
  public open() {
    return this.drawer.open();
  }

  getSubcategories = (tag) => {
    this.store.dispatch(new SubcategoriesTags(tag.id));
  };

  openPlaces = () =>
    this.dialog
      .open(EmployeePlacesComponent, {
        width: "80%",
        height: "80%",
      })
      .afterClosed()
      .subscribe(() => {
        this.drawer.close();
      });

  onError = imgErrorFallback;

  logout = () => {
    this.store.dispatch(new SignOut());
    this.handler(SignOut);
  };

  handler = (action) => {
    this.actions.pipe(ofActionSuccessful(action)).subscribe(() => {
      this._dataService.displayLoading(false);
    });
    this.actions.pipe(ofActionErrored(action)).subscribe(() => {
      this._dataService.displayLoading(false);
    });
  };
}
